import React from 'react';

export const AdminLoading = ({ message = 'Loading...' }) => (
  <div className="flex items-center justify-center py-16">
    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mb-4" />
    <div className="text-lg text-gray-600 font-medium">{message}</div>
  </div>
);
